<div *ngIf="isLoading" class="kiene-loading-spinner">
    <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>
<div class="one-row gruppe-info" style="width: 99%">
    <div style="margin-right: 24px">
        Gruppe:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_1_5_'">{{
            gruppe?.bezeichnung ? gruppe.bezeichnung : "--"
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Abschnitt:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_2_5_'">{{
            gruppe?.produktionsabschnitt ? gruppe.produktionsabschnitt : "--"
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Herdenname:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_3_5_'">{{
            gruppe?.herdenname ? gruppe.herdenname : "--"
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Einstalldatum von:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_4_5_'">{{
            gruppe?.einstalldatum_von | date: "mediumDate"
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Einstalldatum bis:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_5_5_'">{{
            gruppe?.einstalldatum_bis | date: "mediumDate"
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Mastdauer in Tagen (Wochen):
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_6_5_'"
            >{{ gruppe?.alter_tage | number: "1.0-0" }} ({{ gruppe?.alter_wochen | number: "1.0-0" }})</span
        >
    </div>
    <div style="margin-right: 24px">
        Eingestallte Tiere:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_7_5_'">{{
            gruppe?.anzahl_tiere | number: "1.0-0"
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Abg&auml;nge:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_8_5_'">{{
            gruppe?.abgaenge | number: "1.0-0"
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Verlust %:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_9_5_'"
            >{{ gruppe?.verluste | number: "1.0-1" }}%</span
        >
    </div>
    <div style="margin-right: 24px">
        Verluste:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_10_5_'">{{
            gruppe?.tote ? gruppe.tote : (0 | number: "1.0-0")
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Verkauft:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_11_5_'">{{
            gruppe?.verkaeufe | number: "1.0-1"
        }}</span>
    </div>
    <div style="margin-right: 24px">
        Anzahl Tiere:
        <span style="font-weight: bold" [attr.data-cy]="'ggdgd_span_12_5_'">{{
            gruppe?.anzahl_tiere_aktuell | number: "1.0-0"
        }}</span>
    </div>
</div>

<div>
    <ul style="list-style-type: none">
        <li style="margin-top: 12px">
            <div class="one-row">
                <mat-form-field style="width: 50%">
                    <mat-label>Ohrmarke suchen</mat-label>
                    <input matInput type="text" [formControl]="ohrmarkeCtrl" [attr.data-cy]="'ggdgd_input_1_1_'" />
                </mat-form-field>
                <mat-form-field *ngIf="geschlechter?.length && isKaelbermast()" style="width: 220px; margin-left: 16px">
                    <mat-label>Geschlecht</mat-label>
                    <mat-select [formControl]="geschlechtCtrl">
                        <mat-option [value]="null">Alle</mat-option>
                        <mat-option
                            *ngFor="let geschlecht of geschlechter"
                            [value]="geschlecht.geschlecht_id"
                        >
                            {{ geschlecht.bezeichnung }}
                            <ng-container *ngIf="geschlecht.anzahl !== undefined">
                                ({{ geschlecht.anzahl | number: '1.0-0' }})
                            </ng-container>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="isKaelbermast()" style="width: 180px; margin-left: 16px">
                    <mat-label>Alter bis (Tage)</mat-label>
                    <input
                        matInput
                        type="number"
                        [formControl]="alterTageCtrl"
                        placeholder="z.B. 40"
                        min="0"
                    />
                </mat-form-field>
                <span class="spacer" [attr.data-cy]="'ggdgd_span_13_5_'"></span>
                <mat-form-field *ngIf="isKaelbermast()" style="width: 300px">
                    <mat-label>Einstalldatum ausw&auml;hlen</mat-label>
                    <mat-select [formControl]="einstalldatumSelectCtrl">
                        <mat-option>Alle</mat-option>
                        <mat-option *ngFor="let ed of einstalldaten" [value]="ed.einstalldatum"
                            >{{ ed.einstalldatum | date: "dd.MM.yyyy" }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="spacer" [attr.data-cy]="'ggdgd_span_14_5_'"></span>
            </div>
        </li>
    </ul>
    <table style="width: 100%" matSort (matSortChange)="sortTiere($event)">
        <thead>
            <tr>
                <th style="width: 5%; text-align: left">
                    <mat-checkbox
                        *ngIf="auswahl"
                        [checked]="kopfAuswahlAktiv()"
                        (change)="selectAll($event)"
                        [attr.data-cy]="'ggdgd_mat-checkbox_1_3_'"
                    ></mat-checkbox>
                    <span style="padding-left: 4px; font-size: 14px" [attr.data-cy]="'ggdgd_span_15_5_'"
                        >({{ numberSelected }}/{{ anzahlTiereSollwert > 0 ? anzahlTiereSollwert : tiere.length }})</span
                    >
                </th>
                <th style="width: 10%" mat-sort-header="ohrmarke">Ohrmarke</th>
                <th style="width: 5%" mat-sort-header="einstalldatum_notnull"> Einstalldatum </th>
                <th style="width: 5%" mat-sort-header="geburtsdatum"> Geburtsdatum </th>
                <th style="width: 5%" mat-sort-header="geschlecht"> Geschlecht </th>
                <th style="width: 5%" mat-sort-header="abteil"> Abteil </th>
                <th style="width: 10%" mat-sort-header="alter_tage"> Alter in Tagen (Wochen) </th>
                <th style="width: 10%" mat-sort-header="wartezeit"> Wartezeit Fleisch / Milch </th>
                <th style="width: 10%" mat-sort-header="artikel"> Letzte Abgabe </th>
                <th style="width: 5%"></th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="let t of tiere; let j = index"
                style="font-size: 14px"
                [style.background-color]="j % 2 === 0 ? 'whitesmoke' : 'while'"
            >
                <td style="width: 5%" [attr.data-cy]="'ggdgd_td_1_6_'">
                    <mat-checkbox
                        *ngIf="auswahl"
                        [disabled]="numberSelected === anzahlTiereSollwert && !isChecked(t)"
                        [checked]="isChecked(t)"
                        (change)="selectTier($event, t)"
                        [attr.data-cy]="'ggdgd_mat-checkbox_2_3_'"
                    >
                    </mat-checkbox>
                </td>
                <td style="width: 10%; text-align: left; font-size: 0.8em" [attr.data-cy]="'ggdgd_td_2_6_'">
                    <kiene-ohrmarke [ohrmarke]="t?.ohrmarke_notnull || t?.ohrmarke"></kiene-ohrmarke>
                </td>
                <td style="width: 5%; text-align: left" [attr.data-cy]="'ggdgd_td_3_6_'">
                    {{ t?.einstalldatum_notnull | date: "mediumDate" }}
                </td>
                <td style="width: 5%; text-align: left" [attr.data-cy]="'ggdgd_td_4_6_'">
                    {{ t?.geburtsdatum | date: "mediumDate" }}
                </td>
                <td style="width: 5%; text-align: left" [attr.data-cy]="'ggdgd_td_5_6_'">
                    {{ t?.geschlecht }}
                </td>
                <td style="width: 5%; text-align: left" [attr.data-cy]="'ggdgd_td_abteil_6_'">
                    {{ t?.abteil }}
                </td>
                <td style="width: 10%; text-align: left" [attr.data-cy]="'ggdgd_td_6_6_'">
                    {{ t?.alter_tage | number: "1.0-0" }} ({{ t?.alter_wochen | number: "1.0-0" }})
                </td>
                <td [attr.data-cy]="'ggdgd_td_7_6_'">
                    {{ t?.wartezeit_fleisch_bis | date: "mediumDate" }} /
                    {{ t?.wartezeit_milch_bis | date: "mediumDate" }}
                </td>
                <td [attr.data-cy]="'ggdgd_td_8_6_'">{{ t?.artikel }}</td>
                <td style="width: 5%" [attr.data-cy]="'ggdgd_td_9_6_'">
                    <button mat-icon-button [matMenuTriggerFor]="menu" [attr.data-cy]="'ggdgd_button_1_0_'">
                        <mat-icon [attr.data-cy]="'ggdgd_mat-icon_1_2_'">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="abgang(t)" [attr.data-cy]="'ggdgd_button_2_0_'">
                            <mat-icon [attr.data-cy]="'ggdgd_mat-icon_2_2_'">remove_circle</mat-icon>
                            <span [attr.data-cy]="'ggdgd_span_16_5_'">Abgang</span>
                        </button>
                        <button mat-menu-item [attr.data-cy]="'ggdgd_button_3_0_'">
                            <mat-icon [attr.data-cy]="'ggdgd_mat-icon_3_2_'">delete</mat-icon>
                            <span [attr.data-cy]="'ggdgd_span_17_5_'">L&ouml;schen</span>
                        </button>
                    </mat-menu>
                </td>
            </tr>
        </tbody>
    </table>
    <br />
    <div *ngIf="showNachladeButton" class="one-row">
        <span class="spacer" [attr.data-cy]="'ggdgd_span_18_5_'"></span>
        <button mat-stroked-button color="accent" (click)="tiereNachladen()" [attr.data-cy]="'ggdgd_button_4_0_'">
            Nicht ausgewählte Tiere laden
        </button>
        <span class="spacer" [attr.data-cy]="'ggdgd_span_19_5_'"></span>
    </div>
    <mat-paginator
        *ngIf="!identifikation && !selectedAll"
        [length]="totalRecords"
        [showFirstLastButtons]="true"
        [pageSize]="itemsPerPage"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="pageChanged($event)"
    >
    </mat-paginator>
</div>
